import { useTranslation } from 'react-i18next'

import { ButtonSelect } from '../../Select'

import { getPostTypeSelectOptions } from './PostTypeSelect.utils'

function PostTypeSelect(props) {
  const { t } = useTranslation()

  const options = getPostTypeSelectOptions(t)

  return (
    <ButtonSelect
      {...props}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      options={options}
    />
  )
}

export default PostTypeSelect
